import { useEffect, useRef } from 'react';

// The input editor writes to the legacy transform-playbook context directly,
// so chain invalidation hangs off the input value itself. The first-run ref
// keeps opening the drawer from clearing freshly initialized state.
export default function useResetChainOnInputChange({ input, resetChain }) {
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    resetChain();
    // resetChain is recreated each render; the chain only resets when the input changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);
}
